import { PureComponent } from "react";
import PropTypes from "prop-types";
import axios from "axios";

class Redirect extends PureComponent {
  static doRedirect(url) {
    window.location.assign(url);
  }

  static propTypes = {
    url: PropTypes.string,
    source: PropTypes.string,
  };

  static defaultProps = {
    url: null,
    source: null,
  };

  componentDidMount() {
    this._getUrl().then(this.constructor.doRedirect);
  }

  async _getUrl() {
    // Redirect to url specified in url property if set
    if (this.props.url !== null) return this.props.url;

    // Perform request to get target url from source if source url specified
    const { data: { url } } = await axios.get(this.props.source);

    return url;
  }

  render() {
    return null;
  }
}

export default Redirect;
